module.exports = __webpack_public_path__ + "static/media/my-biz-square.d85442f0.png";